(function () {
  // Prevents duplicate observers if the script is included twice
  if (window.__reaFloatingButtonsOffsetReady) return;
  window.__reaFloatingButtonsOffsetReady = true;

  // Bottom values (px) with the PDP sticky bar hidden / visible
  var LAUNCHER_DEFAULT = 70;
  var CONVERSATION_DEFAULT = 145;
  var LAUNCHER_STICKY = 130;
  var CONVERSATION_STICKY = 205;

  var LAUNCHER_MOBILE_DEFAULT = 70;
  var LAUNCHER_MOBILE_STICKY = 117;
  // Keeps the open conversation inside the viewport on mobile
  var CONVERSATION_MOBILE = 0;

  // Aligns the OneTrust button with the Genesys launcher
  var ONETRUST_BTN_BOTTOM_OFFSET = 12;

  // Cart: gap between the top of the sticky checkout and the launcher
  var CART_STICKY_GAP = 16;
  var CONVERSATION_LAUNCHER_GAP = CONVERSATION_DEFAULT - LAUNCHER_DEFAULT;

  // Must match the CSS breakpoint that switches #stickyAddToCart / #stickyAddToCartDesktop
  var MOBILE_MAX_WIDTH = 1000;

  function isMobile() {
    return window.innerWidth < MOBILE_MAX_WIDTH;
  }

  function getPdpStickyBar(mobile) {
    return document.getElementById(mobile ? 'stickyAddToCart' : 'stickyAddToCartDesktop');
  }

  function isPdpStickyBarVisible(mobile) {
    var stickyBar = getPdpStickyBar(mobile);
    if (!stickyBar) return false;
    if (stickyBar.classList.contains('tw-hidden')) return false;

    var computedStyle = window.getComputedStyle(stickyBar);
    if (computedStyle.display === 'none') return false;

    // Mid-fade the opacity is still the old value: the final state is read on transitionend
    if (parseFloat(computedStyle.opacity) < 0.5) return false;

    return true;
  }

  // Cart sticky checkout (rea-cart-sticky): its height changes with the express checkout accordion
  var cartStickyResizeObserver = null;
  var observedCartSticky = null;

  function watchCartStickyHeight(cartSticky) {
    if (cartSticky === observedCartSticky || typeof ResizeObserver === 'undefined') return;

    if (!cartStickyResizeObserver) {
      cartStickyResizeObserver = new ResizeObserver(scheduleUpdate);
    }
    // The theme editor re-creates the section: always observe the current element
    if (observedCartSticky) cartStickyResizeObserver.unobserve(observedCartSticky);
    cartStickyResizeObserver.observe(cartSticky);
    observedCartSticky = cartSticky;
  }

  // Returns null when the cart sticky checkout is not visible
  function getCartLauncherBottom(mobile) {
    var cartSticky = document.querySelector('rea-cart-sticky');
    if (!cartSticky) return null;

    watchCartStickyHeight(cartSticky);

    if (!cartSticky.classList.contains('is-visible')) return null;
    if (window.getComputedStyle(cartSticky).display === 'none') return null;

    var minBottom = mobile ? LAUNCHER_MOBILE_DEFAULT : LAUNCHER_DEFAULT;
    return Math.max(minBottom, cartSticky.offsetHeight + CART_STICKY_GAP);
  }

  function computePositions() {
    var mobile = isMobile();
    var cartBottom = getCartLauncherBottom(mobile);
    var launcher;
    var conversation;

    if (cartBottom !== null) {
      launcher = cartBottom;
      conversation = mobile ? CONVERSATION_MOBILE : cartBottom + CONVERSATION_LAUNCHER_GAP;
    } else {
      // Pages without a sticky bar fall back to the default values
      var pdpVisible = isPdpStickyBarVisible(mobile);

      if (mobile) {
        launcher = pdpVisible ? LAUNCHER_MOBILE_STICKY : LAUNCHER_MOBILE_DEFAULT;
        conversation = CONVERSATION_MOBILE;
      } else {
        launcher = pdpVisible ? LAUNCHER_STICKY : LAUNCHER_DEFAULT;
        conversation = pdpVisible ? CONVERSATION_STICKY : CONVERSATION_DEFAULT;
      }
    }

    return {
      launcher: launcher,
      conversation: conversation,
      oneTrust: launcher + ONETRUST_BTN_BOTTOM_OFFSET
    };
  }

  // Writes only when the value differs: avoids a loop with the MutationObserver
  // and restores the value if Genesys or OneTrust rewrite their inline style
  function setBottom(element, value) {
    if (!element) return;

    var px = value + 'px';
    if (
      element.style.getPropertyValue('bottom') === px &&
      element.style.getPropertyPriority('bottom') === 'important'
    ) {
      return;
    }

    element.style.setProperty('bottom', px, 'important');
  }

  function updateAllPositions() {
    var positions = computePositions();

    setBottom(document.querySelector('.genesys-mxg-launcher-frame'), positions.launcher);
    setBottom(document.querySelector('.genesys-mxg-conversation'), positions.conversation);
    setBottom(document.getElementById('ot-sdk-btn-floating'), positions.oneTrust);
  }

  // At most one update per frame
  var frame = null;

  function scheduleUpdate() {
    if (frame) return;

    frame = requestAnimationFrame(function () {
      frame = null;
      updateAllPositions();
    });
  }

  // Reads the final state of the PDP sticky bar fade
  function onTransitionEnd(event) {
    var stickyBar = getPdpStickyBar(isMobile());
    if (!stickyBar) return;

    var target = event.target;
    if (target === stickyBar || (target.contains && target.contains(stickyBar))) {
      scheduleUpdate();
    }
  }

  function init() {
    // Covers widget injection (Genesys, OneTrust) and sticky bars shown or hidden via class/style
    new MutationObserver(scheduleUpdate).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    document.addEventListener('transitionend', onTransitionEnd);
    document.addEventListener('transitioncancel', onTransitionEnd);
    window.addEventListener('resize', scheduleUpdate);

    updateAllPositions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();